import React from 'react'
import PropTypes from 'prop-types'
import classNames from 'classnames'
import cls from './header-icon-button.module.scss'
import { MaterialIcon } from '~src/new/shared/ui/MaterialIcon/MaterialIcon'
import { Link } from 'react-router-dom'

/**
 * Кнопка уведомлений с бейджем
 */
export const HeaderItem = ({ className, icon, label, to, count, xsIconVisible, isMobile }) => {
  if (xsIconVisible === false && isMobile) return null

  const isPersonIcon = icon === 'person'
  return (
    <Link
      to={to}
      className={classNames(cls.iconButton, cls.iconButtonWithBadge, className, {
        [cls.personIcon]: isPersonIcon,
      })}
    >
      <MaterialIcon
        name={icon}
        ariaLabel={label}
        isSymbol
        slim={false}
        fill={0}
        rounded={isPersonIcon}
        containerSize={36}
      />
      {count > 0 && <span className={cls.badge} />}
    </Link>
  )
}

HeaderItem.propTypes = {
  count: PropTypes.number,
  onClick: PropTypes.func,
  className: PropTypes.string,
}
